'use client';

import { createZustandStore } from '../../zustand';

import { DEFAULT_APP_CONFIG_STATE, IAppConfigState } from './types';

import {
  loadPersistedAppConfig,
  resetAppConfigCallback,
  updateAppColorScheme,
  updateHasViewedCookieForm,
  updateHasWatchedOnboarding,
  updateIsSidebarExpanded,
  updateLocale,
} from './callbacks';

/**
 * This creates an encrypted cached storage of the user's app config on the
 * local device.
 * It contains the user's locale, sidebar & dark mode preference, and whether
 * they have seen the onboarding tour
 */
export const useAppConfigStore = createZustandStore<IAppConfigState>((set) => {
  const {
    appColorScheme,
    hasViewedCookieForm,
    hasWatchedOnboarding,
    isSidebarExpanded,
    locale,
  } = loadPersistedAppConfig() || DEFAULT_APP_CONFIG_STATE;

  return {
    appColorScheme,
    hasViewedCookieForm,
    hasWatchedOnboarding,
    isSidebarExpanded,
    locale,
    setAppColorScheme: updateAppColorScheme(set),
    setHasViewedCookieForm: updateHasViewedCookieForm(set),
    setHasWatchedOnboarding: updateHasWatchedOnboarding(set),
    setIsSidebarExpanded: updateIsSidebarExpanded(set),
    setLocale: updateLocale(set),
    resetAppConfig: resetAppConfigCallback(set),
  };
});
